import React from "react";
import { Link } from "react-router-dom";
import "./css/App.css";

export default function Linktree() {
    return (
        <main className="linktree-page">
            <div className="linktree-container">
                <div className="linktree-header">
                    <img
                        src="/SOLE-logo.svg"
                        alt="SOLE Logo"
                        className="linktree-logo"
                    />
                    <h1 className="linktree-title">Connect with SOLE</h1>
                </div>
                <Link to="/" className="linktree-button">Home</Link>
                <Link to="/candle" className="linktree-button">Candle</Link>

                <Link to="https://discord.gg/8kUtNREn4D" className="linktree-button">Discord</Link>
                <a
                    href="https://soleministries.org/schools/tamu"
                    className="linktree-button"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    TAMU Chapter
                </a>
                <Link to="/subscribe" className="linktree-button">Join Email List</Link>
                <Link to="/donate" className="linktree-button">Donate</Link>
                <a
                    href="https://www.instagram.com/sole_ministries/"
                    className="linktree-button"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Instagram
                </a>


                <Link to="mailto:info@soleministries.org" className="linktree-button">Contact</Link>

                <a
                    href="https://catholicdefensehub.com"
                    className="linktree-button"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Catholic Defense Hub
                </a>
            </div>
        </main>
    );
}
